import { Button, Form as AntdForm, Space } from "antd";
import { FormattedMessage } from "react-intl";
import Form from "components/forms/Form";

import TicketPoolsTable from "../TicketPoolsTable";

import { ticketTemplatePickerFormLayout } from "./consts";
import {
  TicketTemplatePickerFormProps,
  TicketTemplatePickerFormValues,
} from "./types";
import TicketTemplateSelect from "./partials/TicketTemplateSelect";
import { useTicketTemplateTicketPools } from "./hooks";

const TicketTemplatePickerForm: React.FC<TicketTemplatePickerFormProps> = ({
  form,
  ...props
}) => {
  const ticketTemplate = AntdForm.useWatch("ticketTemplate", form);
  const { ticketPools, loading } = useTicketTemplateTicketPools(
    ticketTemplate?.id
  );

  return (
    <Form<TicketTemplatePickerFormValues>
      {...ticketTemplatePickerFormLayout}
      {...{ ...props, form }}
    >
      {(_, __, { isSubmitting }) => (
        <>
          <AntdForm.Item
            name="ticketTemplate"
            rules={[{ required: true }]}
            label={<FormattedMessage defaultMessage="Ticket Template" />}
          >
            <TicketTemplateSelect />
          </AntdForm.Item>
          <Space
            direction="vertical"
            style={{ overflowX: "auto", maxWidth: "100%" }}
          >
            <TicketPoolsTable dataSource={ticketPools} {...{ loading }} />
            <AntdForm.Item>
              <Button type="primary" htmlType="submit" loading={isSubmitting}>
                <FormattedMessage defaultMessage="Submit" />
              </Button>
            </AntdForm.Item>
          </Space>
        </>
      )}
    </Form>
  );
};

export default TicketTemplatePickerForm;
